import styled from 'styled-components';

const Row = styled.div`
    width: ${props => props._width ?? '100%'};
    display: block;
`;

export { Row }